import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import VideocamOutlinedIcon from '@material-ui/icons/VideocamOutlined';
import { Link } from 'react-router-dom';

import AnchorStore from '../../../store/AnchorStore';
import Eila from '../../../assets/GuestHome/MeetTheAnchors/Eila.jpg';
import Alana from '../../../assets/GuestHome/MeetTheAnchors/Alana.png';
import Angel from '../../../assets/GuestHome/MeetTheAnchors/Angel.jpg';
import Cecelia from '../../../assets/GuestHome/MeetTheAnchors/Cecelia.jpg';
import Frankie from '../../../assets/GuestHome/MeetTheAnchors/Frankie.jpg';
import Isabella from '../../../assets/GuestHome/MeetTheAnchors/Isabella.jpg';
import Madison from '../../../assets/GuestHome/MeetTheAnchors/Madison.jpg';
import Marina from '../../../assets/GuestHome/MeetTheAnchors/Marina.jpg';
import Sarah from '../../../assets/GuestHome/MeetTheAnchors/Sarah.jpg';
import Tia from '../../../assets/GuestHome/MeetTheAnchors/Tia.jpg';
import Jaime from '../../../assets/GuestHome/MeetTheAnchors/Jaime.jpg';
import Hanna from '../../../assets/GuestHome/MeetTheAnchors/Hanna.jpg';

import styles from './css/GuestHomePageV2.module.css';

const ANCHOR_IMAGE_MAP = {
  64: Eila,
  71: Marina,
  114: Frankie,
  72: Isabella,
  104: Alana,
  107: Tia,
  79: Madison,
  244: Cecelia,
  79296: Sarah,
  47882: Angel,
  14925: Jaime,
  1277: Hanna,
};

function MeetTheAnchorsV2() {
  const {
    allAnchors,
    setAnchors,
    fetchAvailableMediaTotals,
    mediaTotalForAnchors,
  } = AnchorStore;
  useEffect(() => {
    setAnchors();
    fetchAvailableMediaTotals();
  }, []);

  const getPublicGalleryCount = useCallback((countValue) => {
    const count = countValue || 0;

    return count > 99 ? '99+' : count;
  }, []);

  const anchorsList = useMemo(() => {
    const current = allAnchors?.filter((a) => ANCHOR_IMAGE_MAP?.[a?.id]) || [];

    return [...current].slice(0, 12);
  }, [allAnchors]);

  return (
    <div className={classnames(styles.container, styles.anchorSection)}>
      <h2 className={styles.header}>Meet the Anchors</h2>
      <div className={styles.gridContainer}>
        {anchorsList?.map((anchor) => (
          <Link key={anchor?.name} to={AnchorStore.buildAnchorLink(anchor)}>
            <div
              className={styles.gridItem}
              style={{
                backgroundImage: `url(${ANCHOR_IMAGE_MAP?.[anchor?.id] ||
                  anchor?.anchorsPageImage})`,
              }}
            >
              <div className={styles.anchorName}>
                <p>{anchor?.name?.split(' ')[0]}</p>
              </div>
              <div className={styles.countContainer}>
                <div className={styles.mediaContainer}>
                  <CameraAltOutlinedIcon />
                  {getPublicGalleryCount(
                    mediaTotalForAnchors?.[anchor?.id]?.totalPublicGalleries
                  )}
                </div>
                <div className={styles.mediaContainer}>
                  <VideocamOutlinedIcon />
                  {getPublicGalleryCount(
                    mediaTotalForAnchors?.[anchor?.id]?.totalPublicVideos
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default observer(MeetTheAnchorsV2);
